export default __webpack_public_path__ + "static/media/slider-11.d1751731.jpg";